import { useMemo } from 'react';
import { useTransferData } from '@/shared/hooks/useTransferData';
import { roleService } from '@/services/role.service';
import { Role } from '@/services/types/user.types';
import { RoleModuleType } from '@/shared/enums/RoleModuleType';

type Props = {
  module: RoleModuleType;
};

export function useRoleTransfer({ module }: Props) {
  const fetchFn = useMemo(() => () => roleService.getRolesByModule(module), [module]);

  const { items: roles } = useTransferData<Role>({
    fetchFn,
    mapper: {
      key: (item) => item.id,
      title: (item) => item.name,
      description: (item) => item.description,
      disabled: () => false,
    },
    errorMessage: 'Erro ao buscar dados dos perfis de permissão.',
  });

  return {
    roles,
  };
}
